enum MapLayerToolView {
	Rows,
	Grid,
	GridSmall
}

export default MapLayerToolView;